import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { debugLogger } from '@/utils/debugLogger';

interface AdminPendingActivities {
  waiting_verifications: number;
  pending_verifications: number;
  pending_tickets: number;
  total_pending: number;
}

export const useAdminPendingActivities = () => {
  return useQuery<AdminPendingActivities>({
    queryKey: ['admin-pending-activities'],
    queryFn: async () => {
      debugLogger.debug('[useAdminPendingActivities] Fetching pending activities...');
      
      const { data, error } = await supabase.rpc('get_admin_pending_activities');
      
      if (error) {
        debugLogger.error('[useAdminPendingActivities] Error fetching pending activities', error);
        throw error;
      }
      
      debugLogger.debug('[useAdminPendingActivities] Pending activities fetched:', data);
      
      // Parse o JSONB retornado
      if (typeof data === 'object' && data !== null) {
        return data as unknown as AdminPendingActivities;
      }
      
      // Fallback se não houver dados
      return {
        waiting_verifications: 0,
        pending_verifications: 0,
        pending_tickets: 0,
        total_pending: 0,
      };
    },
    staleTime: 1000 * 60 * 2, // 2 minutos
    refetchInterval: 1000 * 60 * 2, // Refetch a cada 2 minutos
  });
};
